import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,

  changePasswordSuccess: null,
  changePasswordError: null,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {

    // STEP 1: REQUEST VERIFICATION CODE
    case FORGET_PASSWORD:
      return {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        changePasswordSuccess: null,
        changePasswordError: null,
      }

    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        forgetSuccessMsg: action.payload,
        forgetError: null,
      }

    case FORGET_PASSWORD_ERROR:
      return {
        ...state,
        forgetError: action.payload,
        forgetSuccessMsg: null,
      }

    // STEP 2: RESET PASSWORD WITH CODE
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordSuccess: null,
        changePasswordError: null,
      }

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordSuccess: action.payload,
        changePasswordError: null,
	forgetError: null,
        forgetSuccessMsg: null,
      }

    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePasswordError: action.payload,
        changePasswordSuccess: null,
	forgetError: null,
        forgetSuccessMsg: null,
      }

    default:
      return state
  }
}

export default forgetPassword

